module.exports = __webpack_public_path__ + "img/star-unclicked.23880c0d.svg";